import { z } from "zod";
const dateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .refine((value) => {
    const parsed = new Date(`${value}T00:00:00Z`);
    return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
}, "Date invalide");
const timeSchema = z.string().regex(/^(?:[01]\d|2[0-3]):[0-5]\d$/);
const allDayShape = { date: dateSchema, allDay: z.literal(true) };
const timedShape = {
    date: dateSchema,
    allDay: z.literal(false),
    startTime: timeSchema,
    endTime: timeSchema,
};
const ordered = (slot) => slot.allDay ||
    (slot.startTime !== undefined && slot.endTime !== undefined && slot.startTime < slot.endTime);
export const RdvBlockedSlotPayloadSchema = z
    .discriminatedUnion("allDay", [z.object(allDayShape).strict(), z.object(timedShape).strict()])
    .refine(ordered, { message: "La fin doit être après le début.", path: ["endTime"] });
export const RdvBlockedSlotResponseSchema = z.discriminatedUnion("allDay", [
    z.object({ ...allDayShape, id: z.string().uuid(), expiresAt: z.string().datetime() }),
    z.object({ ...timedShape, id: z.string().uuid(), expiresAt: z.string().datetime() }),
]);
export function rdvBlockedSlotWallBounds(slot) {
    if (slot.allDay === false) {
        return {
            startAt: `${slot.date}T${slot.startTime}:00`,
            endAt: `${slot.date}T${slot.endTime}:00`,
        };
    }
    const next = new Date(`${slot.date}T00:00:00Z`);
    next.setUTCDate(next.getUTCDate() + 1);
    return { startAt: `${slot.date}T00:00:00`, endAt: `${next.toISOString().slice(0, 10)}T00:00:00` };
}
//# sourceMappingURL=blockedSlots.js.map